/**
 * Formata número para moeda
 * @param {number} value - Valor
 * @param {Object} options - Opções de formatação
 * @returns {string} Valor formatado
 */
export const formatFloatToPrice = (value, options = {}) => {
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2,
        ...options
    }).format(value)
}